import { render, staticRenderFns } from "./ClientsCrud.vue?vue&type=template&id=3341f314"
import script from "./ClientsCrud.vue?vue&type=script&lang=js"
export * from "./ClientsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports